import {Component} from "preact";
import ToolbarButton from "../../../../../common/toolbar-button";
import CdnResourceResolverService from "../../../../../../services/CdnResourceResolverService";
import Text from "../../../../../common/text";
import CheckIcon from "mdi-preact/CheckIcon";
import Toolbar from "../../../../../layout/toolbar";
import ConfigService from "../../../../../../services/ConfigService";
import LanguageFlagIcon from "../language-flag-icon";

export default class LanguageSelectorItem extends Component {
    static defaultProps = {
        language: '',
        onClick: () => {}
    };

    render(props, state, context) {
        const language = ConfigService.currentLanguage();

        return (
            <ToolbarButton type={'fill text'} onClick={props.onClick}>
                <LanguageFlagIcon  language={props.language}/>
                <Text text={'language.' + props.language}/>
                {props.language === language ? <CheckIcon style={{float: 'right'}}/> : null}
            </ToolbarButton>
        );
    }

    onImageError = () => {
        this.setState({imageError: true});
    }
}


// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/user/language-selector-item/index.js